// extracted by mini-css-extract-plugin
module.exports = {"inner":"Header_inner__P_QaN","link":"Header_link__bybi9","linkLabel":"Header_linkLabel__IPfc3","icon":"Header_icon__qx0AQ"};